import BuilderModal from "lib/components/builders/communities/plans/modals/BuilderModal";
import type { ReactNode } from "react";
import Button from "ui/buttons/Button";
import IconNotes from "ui/icons/IconNotes";
import styles from "./Modal.module.scss";

interface Props {
  errorTitle: string;
  errorMessage: string;
  onClose: () => void;
  action?: ReactNode;
}

export default function ErrorModal({ errorTitle, errorMessage, onClose, action }: Props) {
  return (
    <BuilderModal
      onClose={onClose}
      open
      variants={["footerButtons"]}
      footer={
        <>
          <Button btnStyle="tertiary" btnSize="large" onClick={onClose}>
            Close
          </Button>
          {action}
        </>
      }
    >
      <div className="modal-body">
        <div className={styles.wrapper}>
          <div className="icon-wrapper">
            <IconNotes size={30} color="ruby" />
          </div>
          <div className="error-wrapper">
            <div className="error-wrapper-text">{errorTitle}</div>
          </div>

          <div className="message-row">
            <div className="message-text">{errorMessage}</div>
          </div>
        </div>
      </div>
    </BuilderModal>
  );
}
